import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react'
import { useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'

//components
import Filter from './partials/Filter'
import Pagination from '../../../app/Pagination'
import Table from './partials/Table'

//images
import loader from '../../../../assets/images/app/loader.svg'
import notFoundIcon from '../../../../assets/images/pages/icons/not-found.png'

//modals
import CreateEditModal from './modals/CreateEdit'
import ForemanBalanceModal from './modals/ForemanBalance'

//contexts
import { useFinanceContext } from '../../../../_contexts/FinananceContex'
import { useAuthContext } from '../../../../_contexts/AuthContext'

let timeout
function Index(props, ref) {
    const financeContext = useFinanceContext()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const auth = useAuthContext()
    const isAdmin = auth.user.data.role_id == 3

    const [materials, setMaterials] = useState({
        filter: {
            project_id: '',
            fromdate: '',
            todate: '',
            name: '',
            user_id: '',
            expense_id: '',
            price: 'price-asc',
            date_sort: 'date-asc',
            payment_type_id: ''
        },
        loading: true,
        data: [],
        pages: 1,
        page: searchParams.get('page') || 1,
        refresh: null,
    })

    //refs
    const createEditRef = useRef(null)
    const addBalanceRef = useRef(null)
    //end refs

    useImperativeHandle(ref, () => ({
        filter: (key, val) => handleFilter(key, val),
    }))

    useEffect(() => {
        startLoading()

        let url = `expense/getall?project_id=${materials.filter.project_id}`
            + `&fromdate=${materials.filter.fromdate}`
            + `&todate=${materials.filter.todate}`
            + `&name=${materials.filter.name}`
            + `&page=${materials.page}`
            + `&sort=${materials.filter.price}`
            + `&date_sort=${materials.filter.date_sort}`
            + `&payment_type_id=${materials.filter.payment_type_id}`
            + `&user_id=${materials.filter.user_id}`
            + `&expense_id=${materials.filter.expense_id}`

        Api.get(url)
            .then(res => {
                setMaterials(materials => ({
                    ...materials,
                    data: res.data.result,
                    pages: res.data.page
                }))
                financeContext.setData({
                    expense: res.data.expense_total,
                    income: res.data.income_total,
                    remaining: res.data.remaining,
                    foreman: res.data.foreman,
                    expense_type: res.data.expense_type
                })
            })
            .finally(() => stopLoading())
    }, [materials.page, materials.filter, materials.refresh])
    const startLoading = () => {
        setMaterials(materials => ({
            ...materials,
            loading: true,
        }))
    }
    const stopLoading = () => {
        setMaterials(materials => ({
            ...materials,
            loading: false,
        }))
    }

    const handleFilter = (key, val, delay = 0) => {
        clearTimeout(timeout)

        timeout = setTimeout(() => {
            setMaterials(prev => ({
                ...prev,
                filter: {
                    ...prev.filter,
                    [key]: val
                }
            }))
        }, delay)
    }

    const handlePage = page => {
        setMaterials(materials => ({
            ...materials,
            page: page.selected + 1
        }))
    }

    //refresh
    const handleRefreshData = () => {
        setMaterials(materials => ({
            ...materials,
            refresh: new Date()
        }))
    }

    const handlePriceFilter = () => {
        setMaterials(materials => ({
            ...materials,
            filter: {
                ...materials.filter,
                price: materials.filter.price == 'price-asc' ? 'price-desc' : 'price-asc',
                date_sort: ''
            }
        }))
    }

    const handleDateFilter = () => {
        setMaterials(materials => ({
            ...materials,
            filter: {
                ...materials.filter,
                date_sort: materials.filter.date_sort == 'date-asc' ? 'date-desc' : 'date-asc',
                price: ''
            }
        }))
    }

    const handleEdit = (id, expense_id) => {
        if (expense_id == 7) {
            addBalanceRef.current.open(id, expense_id)
        } else {
            createEditRef.current.open(id)
        }
    }


    const handleFail = (val) => {
        props.handleFail2(val)
    }

    const handleCreate = () => createEditRef.current.open()
    const handleAddBalance = () => addBalanceRef.current.open()
    return (
        <div className="wrapper task">
            <CreateEditModal
                ref={createEditRef}
                handleRefreshData={handleRefreshData}
            />
            <ForemanBalanceModal
                ref={addBalanceRef}
                handleRefreshData={handleRefreshData}
            />
            <div style={{ justifyContent: 'flex-end' }} className="top row">
                <span>

                </span>

                <div className='col'>
                    <button className="btn-add" onClick={handleCreate}>
                        Разход
                    </button>
                </div>
                {isAdmin ?
                    <div className='col'>
                        <button className="btn-add" onClick={handleAddBalance}>
                            Добави баланс
                        </button>
                    </div>
                    : ''
                }
            </div>

            <div className="row">
                <Filter
                    handleFilter={handleFilter}
                    handleFail={handleFail}
                    data={materials.filter}
                />
            </div>

            {materials.loading ?
                <img src={loader} alt="loading" />
                :
                materials.data.length == 0 ?
                    <div className="no-results">
                        <img src={notFoundIcon} alt="Няма резултати" />
                        Не бяха намерени резултати.
                    </div>
                    :
                    <>
                        <Table
                            materials={materials.data}
                            handleEdit={handleEdit}
                            priceFilter={handlePriceFilter}
                            dateFilter={handleDateFilter}
                            priceFilterApplied={materials.filter.price}
                            dateFilterApplied={materials.filter.date_sort}
                        />
                        <div className="row">
                            <Pagination
                                page={materials.page}
                                pages={materials.pages}
                                handlePage={handlePage}
                            />
                        </div>
                    </>
            }
        </div>
    )
}

export default forwardRef(Index)